import { render, staticRenderFns } from "./InsertVaribleDropdown.vue?vue&type=template&id=38f7e7b2&scoped=true"
import script from "./InsertVaribleDropdown.vue?vue&type=script&lang=js"
export * from "./InsertVaribleDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f7e7b2",
  null
  
)

export default component.exports